import { BrowserRouter } from "react-router-dom";
import RouterlessApp from "./routerless-app";

function App() {
  const basename = process.env.REACT_APP_APP_ROUTE_PREFIX;
  return (
    <BrowserRouter basename={basename}>
      <RouterlessApp />
    </BrowserRouter>
  );
}

export default App;
